// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../statics/msg_search_result_icon_launch.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../statics/msg_search_result_icon_shrink.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_container__ZFw20 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: #fff;
}

.home_sidebar__eLge2 {
    width: 280px;
    height: 100%;
    overflow-x: hidden;
    transition: all 0.5s ease;
}

.home_hide_sidebar__EOx8U {
    /* display: none; */
    width: 0;
    overflow-x: hidden;
}

.home_content__hdnO4 {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - 280px);
    height: 100%;
    transition: all 0.5s ease;
}

.home_content_zoom__LPjBY {
    width: 100%;
}

.home_side_arrow__uf2eB {
    position: absolute;
    left: 0;
    top: calc(50% - 11px);
    width: 22px;
    height: 22px;
}

.home_header__8QzKd {
    width: 100%;
    height: 53px;
}

@keyframes home_fadeInModel__f68Vf {
    0% { opacity: 0; }
    100% { opacity: 1; }
}

.home_ease_in_out__0MNBm {
    animation: home_fadeInModel__f68Vf 0.5s ease-in-out forwards;
}

.home_main__DVDFJ {
    width: 100%;
    height: calc(100% - 53px);
}

.home_gpt_box__udmv6 {
    display: flex;
    width: 290px;
    height: 40px;
    border-radius: 6px;
}

.home_gpt_item__FQR9M {
    width: 145px;
    height: 100%;
    background-color: #fff;
    border: 1px solid #d8dde2;
    cursor: pointer;
}

.home_gpt_sel_done__HuKbP {
    background-color: #4f4f4f;
}

.msg_search_result_container {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 16px;
}

.msg_search_result_title_box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 26px;
    font-size: 13px;
    color: #3568FF;
    margin-bottom: 10px;
}

.msg_search_result_title {
    padding-right: 10px;
    cursor: pointer;
}

.msg_search_result_title_icon {
    width: 11px;
    height: 6px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
    cursor: pointer;
}

.msg_search_result_container_shrink .msg_search_result_title_icon {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
}

.msg_search_result_container_shrink .msg_search_result_item_box {
    display: none;
}

.msg_search_result_item_box {
    width: 100%;
    display: none;
    display: flex;
    flex-wrap: wrap;
}

.msg_search_result_item_link {
    color: #323a45 !important;
    text-decoration: none;
    width: calc(100% - 30px);
}

.msg_search_result_item_link:hover {
    text-decoration: none !important;
}

.msg_search_result_item {
    width: 100%;
    display: flex;
}

.msg_search_result_item_n {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    margin-top: 2px;
    margin-right: 10px;
    background-color: #e4f0f2;
}

.msg_search_result_item_info {
    width: 100%;
    height: auto;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;          /* 定义文本的行数 */
    text-overflow: ellipsis;
    /* white-space: nowrap; */
    overflow: hidden;
    max-height: 50px;
    font-size: 14px;
}

.msg_search_result_item_info_title {
    font-weight: bold;
}

.msg_search_result_item_info_text {

}

.msg_search_result_item_line {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e2e5e9;
    margin-top: 15px;
    margin-bottom: 15px;
}

.home_content_drag_area_modal__\\+DQJG {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: flex-end;
}

.home_content_drag_area_modal_none__LsdrO {
    align-items: center;
}

.home_content_drag_area_modal_none__LsdrO .home_content_drag_area_box__v2eZU {
    margin-top: 50px;
    margin-bottom: 0;
}

.home_content_drag_area_box__v2eZU {
    width: 60%;
    height: 170px;
    padding: 0 112px 0 55px;
    margin-bottom: 38px;
}

.home_content_drag_area__nEA6K {
    width: 100%;
    height: 100%;
    padding: 10px;
    border: 1px solid #C3C7CF;
    background-color: #ffffff;
    border-radius: 6px;
}

.home_content_drag_dashed__8ItWh {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border: 1px dashed #C3C7CF;
    border-radius: 6px;
    background-color: #f2f8f9;
}

.home_content_drag_title__SEPzj {
    font-size: 24px;
    font-weight: bold;
    line-height: 30px;
    margin-top: 10px;
    margin-bottom: 5px;
}

.home_content_drag_text__qWXr9 {
    font-size: 16px;
    line-height: 20px;
}

.home_custome_drag_area_upload__cS\\+8i .ant-upload-drag {
    border: none;
}

.home_custome_drag_area_upload__cS\\+8i .ant-upload {
    padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,KAAK,UAAU,EAAE;IACjB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,4DAAgD;AACpD;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gFAA+F;IAC/F,eAAe;AACnB;;AAEA;IACI,gFAA+F;AACnG;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB,WAAW,YAAY;IAC5C,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;AAEA;;AAEA;IACI,WAAW;IACX,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,0CAA0C;IAC1C,aAAa;IACb,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    background-color: #fff;\n}\n\n.sidebar {\n    width: 280px;\n    height: 100%;\n    overflow-x: hidden;\n    transition: all 0.5s ease;\n}\n\n.hide_sidebar {\n    /* display: none; */\n    width: 0;\n    overflow-x: hidden;\n}\n\n.content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: calc(100% - 280px);\n    height: 100%;\n    transition: all 0.5s ease;\n}\n\n.content_zoom {\n    width: 100%;\n}\n\n.side_arrow {\n    position: absolute;\n    left: 0;\n    top: calc(50% - 11px);\n    width: 22px;\n    height: 22px;\n}\n\n.header {\n    width: 100%;\n    height: 53px;\n}\n\n@keyframes fadeInModel {\n    0% { opacity: 0; }\n    100% { opacity: 1; }\n}\n\n.ease_in_out {\n    animation: fadeInModel 0.5s ease-in-out forwards;\n}\n\n.main {\n    width: 100%;\n    height: calc(100% - 53px);\n}\n\n.gpt_box {\n    display: flex;\n    width: 290px;\n    height: 40px;\n    border-radius: 6px;\n}\n\n.gpt_item {\n    width: 145px;\n    height: 100%;\n    background-color: #fff;\n    border: 1px solid #d8dde2;\n    cursor: pointer;\n}\n\n.gpt_sel_done {\n    background-color: #4f4f4f;\n}\n\n:global(.msg_search_result_container) {\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 16px;\n}\n\n:global(.msg_search_result_title_box) {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 26px;\n    font-size: 13px;\n    color: #3568FF;\n    margin-bottom: 10px;\n}\n\n:global(.msg_search_result_title) {\n    padding-right: 10px;\n    cursor: pointer;\n}\n\n:global(.msg_search_result_title_icon) {\n    width: 11px;\n    height: 6px;\n    background: url('../../statics/msg_search_result_icon_launch.png') no-repeat center / 100% 100%;\n    cursor: pointer;\n}\n\n:global(.msg_search_result_container_shrink .msg_search_result_title_icon) {\n    background: url('../../statics/msg_search_result_icon_shrink.png') no-repeat center / 100% 100%;\n}\n\n:global(.msg_search_result_container_shrink .msg_search_result_item_box) {\n    display: none;\n}\n\n:global(.msg_search_result_item_box) {\n    width: 100%;\n    display: none;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n:global(.msg_search_result_item_link) {\n    color: #323a45 !important;\n    text-decoration: none;\n    width: calc(100% - 30px);\n}\n\n:global(.msg_search_result_item_link:hover) {\n    text-decoration: none !important;\n}\n\n:global(.msg_search_result_item) {\n    width: 100%;\n    display: flex;\n}\n\n:global(.msg_search_result_item_n) {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n    margin-top: 2px;\n    margin-right: 10px;\n    background-color: #e4f0f2;\n}\n\n:global(.msg_search_result_item_info) {\n    width: 100%;\n    height: auto;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;          /* 定义文本的行数 */\n    text-overflow: ellipsis;\n    /* white-space: nowrap; */\n    overflow: hidden;\n    max-height: 50px;\n    font-size: 14px;\n}\n\n:global(.msg_search_result_item_info_title) {\n    font-weight: bold;\n}\n\n:global(.msg_search_result_item_info_text) {\n\n}\n\n:global(.msg_search_result_item_line) {\n    width: 100%;\n    height: 1px;\n    border-top: 1px solid #e2e5e9;\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n\n.content_drag_area_modal {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    background-color: rgba(255, 255, 255, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n}\n\n.content_drag_area_modal_none {\n    align-items: center;\n}\n\n.content_drag_area_modal_none .content_drag_area_box {\n    margin-top: 50px;\n    margin-bottom: 0;\n}\n\n.content_drag_area_box {\n    width: 60%;\n    height: 170px;\n    padding: 0 112px 0 55px;\n    margin-bottom: 38px;\n}\n\n.content_drag_area {\n    width: 100%;\n    height: 100%;\n    padding: 10px;\n    border: 1px solid #C3C7CF;\n    background-color: #ffffff;\n    border-radius: 6px;\n}\n\n.content_drag_dashed {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    border: 1px dashed #C3C7CF;\n    border-radius: 6px;\n    background-color: #f2f8f9;\n}\n\n.content_drag_title {\n    font-size: 24px;\n    font-weight: bold;\n    line-height: 30px;\n    margin-top: 10px;\n    margin-bottom: 5px;\n}\n\n.content_drag_text {\n    font-size: 16px;\n    line-height: 20px;\n}\n\n.custome_drag_area_upload :global(.ant-upload-drag) {\n    border: none;\n}\n\n.custome_drag_area_upload :global(.ant-upload) {\n    padding: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `home_container__ZFw20`,
	"sidebar": `home_sidebar__eLge2`,
	"hide_sidebar": `home_hide_sidebar__EOx8U`,
	"content": `home_content__hdnO4`,
	"content_zoom": `home_content_zoom__LPjBY`,
	"side_arrow": `home_side_arrow__uf2eB`,
	"header": `home_header__8QzKd`,
	"ease_in_out": `home_ease_in_out__0MNBm`,
	"fadeInModel": `home_fadeInModel__f68Vf`,
	"main": `home_main__DVDFJ`,
	"gpt_box": `home_gpt_box__udmv6`,
	"gpt_item": `home_gpt_item__FQR9M`,
	"gpt_sel_done": `home_gpt_sel_done__HuKbP`,
	"content_drag_area_modal": `home_content_drag_area_modal__+DQJG`,
	"content_drag_area_modal_none": `home_content_drag_area_modal_none__LsdrO`,
	"content_drag_area_box": `home_content_drag_area_box__v2eZU`,
	"content_drag_area": `home_content_drag_area__nEA6K`,
	"content_drag_dashed": `home_content_drag_dashed__8ItWh`,
	"content_drag_title": `home_content_drag_title__SEPzj`,
	"content_drag_text": `home_content_drag_text__qWXr9`,
	"custome_drag_area_upload": `home_custome_drag_area_upload__cS+8i`
};
export default ___CSS_LOADER_EXPORT___;
